import { render, staticRenderFns } from "./FooterLight.vue?vue&type=template&id=748d44fe&scoped=true&"
import script from "./FooterLight.vue?vue&type=script&lang=js&"
export * from "./FooterLight.vue?vue&type=script&lang=js&"
import style0 from "./FooterLight.vue?vue&type=style&index=0&id=748d44fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d44fe",
  null
  
)

component.options.__file = "FooterLight.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VFooter,
  VSpacer,
})
